import React, { useEffect, useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';

// ============ FIXED: Handle both with and without /api prefix ============
const getBaseURL = () => {
  const url = process.env.REACT_APP_API_URL || 'http://localhost:5000';
  const cleanUrl = url.replace(/\/$/, '');
  if (cleanUrl.endsWith('/api')) {
    return cleanUrl;
  }
  return `${cleanUrl}/api`;
};

const API_URL = getBaseURL();

const AdminWithdrawals = () => {
  const [withdrawals, setWithdrawals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedWithdrawal, setSelectedWithdrawal] = useState(null);
  const [notes, setNotes] = useState('');

  useEffect(() => {
    fetchWithdrawals();
  }, []);

  const fetchWithdrawals = async () => {
    try {
      const token = localStorage.getItem('token');
      // ✅ FIXED: Using API_URL with auto /api prefix
      const response = await axios.get(`${API_URL}/withdrawals/all`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setWithdrawals(response.data.withdrawals);
    } catch (error) {
      toast.error('Failed to load withdrawals');
    } finally {
      setLoading(false);
    }
  };

  const processWithdrawal = async (id, status) => {
    try {
      const token = localStorage.getItem('token');
      // ✅ FIXED: Using API_URL with auto /api prefix
      await axios.put(`${API_URL}/withdrawals/process/${id}`, 
        { status, notes },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success(`Withdrawal ${status} successfully`);
      setSelectedWithdrawal(null);
      setNotes('');
      fetchWithdrawals();
    } catch (error) {
      toast.error('Processing failed');
    }
  };

  if (loading) {
    return <div className="text-center py-8">Loading...</div>;
  }

  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold mb-6">Withdrawal Requests</h1>
      
      <div className="overflow-x-auto">
        <table className="w-full bg-white rounded-lg shadow">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left">Investor</th>
              <th className="px-6 py-3 text-left">Amount</th>
              <th className="px-6 py-3 text-left">Bank Details</th>
              <th className="px-6 py-3 text-left">Date</th>
              <th className="px-6 py-3 text-left">Status</th>
              <th className="px-6 py-3 text-left">Action</th>
            </tr>
          </thead>
          <tbody className="divide-y">
            {withdrawals.map((w) => (
              <tr key={w._id}>
                <td className="px-6 py-4">
                  <div className="font-medium">{w.user?.name}</div>
                  <div className="text-sm text-gray-500">{w.user?.email}</div>
                </td>
                <td className="px-6 py-4 font-bold text-green-600">₹{w.amount.toLocaleString()}</td>
                <td className="px-6 py-4 text-sm">
                  <div>A/c: {w.bankAccount}</div>
                  <div>IFSC: {w.ifsc}</div>
                </td>
                <td className="px-6 py-4 text-sm">{new Date(w.createdAt).toLocaleDateString()}</td>
                <td className="px-6 py-4">
                  <span className={`px-2 py-1 text-xs rounded-full ${
                    w.status === 'pending' ? 'bg-yellow-100 text-yellow-800' :
                    w.status === 'approved' ? 'bg-green-100 text-green-800' :
                    'bg-red-100 text-red-800'
                  }`}>
                    {w.status}
                  </span>
                </td>
                <td className="px-6 py-4">
                  {w.status === 'pending' && (
                    <button
                      onClick={() => setSelectedWithdrawal(w)}
                      className="bg-green-600 text-white px-3 py-1 rounded text-sm hover:bg-green-700"
                    >
                      Process
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Process Modal */}
      {selectedWithdrawal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl p-6 max-w-md w-full">
            <h2 className="text-xl font-bold mb-4">Process Withdrawal</h2>
            <div className="space-y-3 mb-4">
              <p><strong>Investor:</strong> {selectedWithdrawal.user?.name}</p>
              <p><strong>Amount:</strong> <span className="text-green-600 font-bold">₹{selectedWithdrawal.amount.toLocaleString()}</span></p>
              <p><strong>Bank Account:</strong> {selectedWithdrawal.bankAccount}</p>
              <p><strong>IFSC:</strong> {selectedWithdrawal.ifsc}</p>
              <div>
                <label className="block text-sm font-medium mb-1">Notes (Optional)</label>
                <textarea
                  value={notes}
                  onChange={(e) => setNotes(e.target.value)}
                  className="w-full border rounded-lg px-3 py-2"
                  rows="2"
                  placeholder="Add any notes..."
                />
              </div>
            </div>
            <div className="flex gap-3">
              <button
                onClick={() => processWithdrawal(selectedWithdrawal._id, 'approved')}
                className="flex-1 bg-green-600 text-white py-2 rounded-lg hover:bg-green-700"
              >
                Approve
              </button>
              <button
                onClick={() => processWithdrawal(selectedWithdrawal._id, 'rejected')}
                className="flex-1 bg-red-600 text-white py-2 rounded-lg hover:bg-red-700"
              >
                Reject
              </button>
              <button
                onClick={() => setSelectedWithdrawal(null)}
                className="flex-1 border border-gray-300 py-2 rounded-lg hover:bg-gray-50"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminWithdrawals;